import React, {useState, useCallback, useEffect} from 'react';
import {setEffectParameterValues} from 'actions/index.js';
import {trim} from "utils/trim.js"
import PulseLoader from 'react-spinners/PulseLoader'
import ethereum from 'decentralized/ethereum.js';
import ipfs from 'decentralized/Ipfs.js';
import {newEffectPreset, getEffectPresets} from 'decentralized/effects/EffectPresets.js';

export default ({effect, hide, sequencerEngine, trackNumber}) => {
    const [saveName, setSaveName] = useState('');
    const [presets, setPresets] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const savePreset = useCallback(() => {
        let json = effect.getJson();
        newEffectPreset(json, saveName);
        hide();
    }, [saveName, hide, effect]);

    const loadPreset = useCallback(async (preset) => {
        setIsLoading(preset);
        let json = await ipfs.getJson(preset.effectHash);
        let bulk = await effect.fromJson(json, sequencerEngine.tracks, trackNumber, true, false);
        if (effect.track && effect.track.loadLostParameters) {
            effect.track.loadLostParameters();
        }
        effect.preset = preset.effectHash;
        sequencerEngine.dispatch(setEffectParameterValues(bulk));
        setIsLoading(undefined);
        hide();
    }, [setIsLoading, effect]);

    useEffect(() => {
        getEffectPresets(effect.name).then(
            p => setPresets(p));
    }, [setPresets, effect]);

    let saveButtonClass = "save-button";
    if (saveName === '') {
        saveButtonClass += " disabled";
    }
    return (
        <div className="effect-presets">
         <div className="presets-container">
            {presets.map(
                preset => <Preset
                            id={preset.effectHash}
                            isLoading={preset === isLoading}
                            isSelected={preset.effectHash === effect.preset}
                            onClick={() => loadPreset(preset)}
                            preset={preset}/>)}
          </div>
          
          <div className="save-container">
            <input
              type="text"
              className="save-input"
              placeholder="Type name to save"
              value={saveName}
              onChange={(e) => setSaveName(e.target.value)}
            />
            <div
              onClick={savePreset}
              className={saveButtonClass}>
              SAVE
            </div>
          </div>
        </div>
    );
};

const Preset = ({preset, onClick, isSelected, isLoading}) => {
    const [author, setAuthor] = useState('');

    useEffect(() => {
        ethereum.users.getUserName(preset.user)
            .then(name => setAuthor(name));
    }, [setAuthor]);

    let className = "effect-preset";
    if (isSelected) {
        className += " selected";
    }
    if (isLoading) {
        className += " loading";
    }
    return (
        <div
          onClick={onClick}
          className={className}>
          <div className="preset-title">
            {trim(preset.title)}
          </div>
          <div className="preset-author">
            {author}
          </div>
        </div>
    );
};
